/**
 * @voltxampere/ui — DTR/RTS auto-reset module variant (Sprint 49-6)
 *
 * Arduino-compatible auto-reset circuit. The Arduino IDE pulses the
 * USB-UART's DTR (or RTS on some clones) line low for ~2 ms; the
 * 100 nF capacitor + 10 kΩ pull-up generates a brief negative-going
 * pulse on the AVR's RESET pin, restarting the bootloader.
 *
 * Topology:
 *   USB-UART DTR/RTS → 100 nF cap → AVR RESET pin
 *                                  + 10 kΩ pull-up to VCC
 *
 * Reference: Arduino UNO R3 schematic (Rev3 2014), section
 * "Reset circuit" + ATmega16U2/CH340 RESET tied via DTR.
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * for VCC; cap + pull-up modeled as separate passive components in
 * the user's schematic when needed for accuracy.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const circuitDtrRtsReset = {
    id: "dtr-rts-reset",
    nameTr: "DTR/RTS Auto-Reset Modülü (Arduino)",
    nameEn: "DTR/RTS Auto-Reset Module (Arduino)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "DTR-RST",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        busType: "uart-handshake",
        capacitorNf: 100,
        pullupKohm: 10,
        pulseWidthMs: 2,
        targetPin: "RESET",
        sourcePin: "DTR",
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=circuit-dtr-rts-reset.js.map